export interface ILogin {
    email: string;
    password: string;
}

export interface IRefresh {
    refresh_token: string;
    user_id: string;
}

export interface ILoginv2 {
    username: string;
    password: string;
}

export interface IAgentLoginInfo {
    username: string;
    access_token: string;
    expires_in: number;
    token_type: string;
    scope: string;
    bankBsb: string;
    bankAccount: string;
    bankCountryShortCode: string;
    businessnumber: string;
    tradingname: string;
}

export interface IGoogleLogin {
    google_access_token: string;
}
export interface IAppleLogin {
    access_token: string;
    /**
     * Only present on a first authorisation, where Apple sends the name once and
     * never again. `POST /user/login/apple` takes both as optional and writes
     * them when it creates the account.
     */
    first_name?: string;
    last_name?: string;
}

export interface ISignUp {
    first_name?: string;
    last_name?: string;
    email: string;
    password: string;
    skip_otp?: boolean;
    is_password_randomly_generated?: boolean;
}
export interface ISignUpEmail {
    email: string;
}

export interface ISignUpName {
    first_name: string;
    last_name: string;
}

export interface ISignUpPassword {
    password: string;
    ReEnterPassword: string;
}

export interface ILoginDemo {
    email: string;
    password: string;
}

export interface IAuthAgentData {
    access_token: string;
    expires_in: number;
    token_type: string;
    scope: string;
    username: string;
    user_id: string;
    updated_at: string;
    created_at: string;
    id: number;
}

export interface IJwtData {
    accessToken: string;
    refreshToken: string;
}

export interface IAuth {
    success: boolean;
    data: IAuthAgentData;
    message: string;
    code: number;
}

export enum IAuthType {
    EMAIL = "email",
    APPLE = "apple",
    GOOGLE = "google",
    FACEBOOK = "facebook",
}

export interface IAccountResponse {
    success: boolean;
    title: string;
    data: IAccount;
    code: number;
}

export interface IAccount {
    title: string;
    id: string;
    first_name: string | null;
    last_name: string | null;
    email: string;
    sso_type: IAuthType;
    profile_status: string;
    is_agent_integrated: boolean;
    is_points_displayed: boolean;
    date_of_birth: string;
    is_email_verified: boolean;
    is_password_randomly_generated: boolean;
    created_at: string;
    phone_number: string;
    post_code: string;
    country_code: string;
}

export interface IAuthLogin {
    success: boolean;
    title: string;
    data: {
        accessToken: string;
        refreshToken: string;
    };
    code: number;
}

export interface IRefreshAccessToken {
    accessToken: string;
}
export interface ISetRealEmail {
    new_email: string;
}

export interface IVerifyRealEmail {
    otp: string;
}

export interface IForgotPassEmail {
    email: string;
}
export interface IForgotPassword {
    new_password: string;
    /**
     * The emailed code and the address it went to. Both are required by
     * `/user/email/reset-password/` despite the endpoint's name suggesting
     * otherwise — this is the reset that proves identity by code rather than by
     * the current password.
     */
    otp: string;
    email: string;
}
export interface IChangePassword {
    new_password: string;
    current_password: string;
    is_password_randomly_generated?: boolean;
}

export interface IAuthenticationCode {
    otp: string;
    /**
     * Required by POST /user/email/otp/verify — its validator is
     * ['email' => 'required|email', 'otp' => 'required'], so omitting this
     * returns 400 "Validation Error." rather than a wrong-code message.
     */
    email: string;
}

export interface IResetPassword {
    password: string;
    confirmPassword: string;
}

export interface IAgentInfo {
    bankBsb: string;
    bankAccount: string;
    bankCountryShortCode?: string;
    businessnumber: string;
    tradingname: string;
}
